// CP-135: the Detail "Show all cabin types" toggle only appears when it
// would reveal more than one cabin. With one cabin type (or none in the
// selected range) the toggle is hidden and that one cabin is shown as is.

// Cabin types that have a price tile, keyed like pricesByType.
export function cabinTypeCount(pricesByType) {
  if (!pricesByType || typeof pricesByType !== 'object') return 0;
  return Object.keys(pricesByType).length;
}

// True only when expanding would show a different set of cabins.
export function showsCabinTypeToggle(pricesByType) {
  return cabinTypeCount(pricesByType) >= 2;
}

// Cabin types shown while collapsed: Interior (unchanged), or the only
// cabin type when there is just one, so hiding the toggle cannot leave
// that cabin unreachable.
export function collapsedCabinTypes(pricesByType) {
  const types = pricesByType && typeof pricesByType === 'object'
    ? Object.keys(pricesByType)
    : [];
  const interior = types.find((type) => type.toLowerCase().includes('interior'));
  if (interior) return [interior];
  if (types.length === 1) return [types[0]];
  return [];
}
